export default "__VITE_ASSET__CfLp9GXZ__"